import { formatDate } from '@/shared/lib/utils/date/format-date'
import Flex from '@/shared/ui/Flex/ui/Flex'

import styles from './PromotionSummary.module.scss'

export type PromotionSummaryProps = {
	ACTIVE_TO: string
}

export const PromotionSummary = ({ ACTIVE_TO }: PromotionSummaryProps): JSX.Element => {
	const saleTime = formatDate(ACTIVE_TO)

	return (
		<article className={styles.promotionSummary}>
			<Flex column>
				{/* Time period info */}
				<dl className={styles.item}>
					<dt className={styles.name}>Сроки проведения:</dt>
					<dd className={styles.value}>до {saleTime}</dd>
				</dl>
			</Flex>
		</article>
	)
}
